import React from 'react';
import { useLogger } from '../../../../../modernization-common/hooks/use-logger';
import type { NodeT } from '../../../types';
import { LabelText } from '../common/label-text';
type PropsT = {
  nodes: NodeT[];
  activeIndex?: number | null;
  color?: string;
  outlined?: boolean;
};
const LABEL_OFFSET_Y = -10;
export const NodeLabels = ({
  nodes,
  activeIndex,
  color,
  outlined
}: PropsT) => {
  const logger = useLogger();
  return <>
      {nodes.map((node, index) => {
      const label = node.id;
      if (label.length === 0) {
        logger?.error('Node label is empty: ', node);
        return null;
      }
      const isActive = index === activeIndex;
      return <LabelText key={`node-label-${node.id}`} x={node.point[0]} y={node.point[1] + LABEL_OFFSET_Y} textAnchor="middle" $originX={node.point[0]} $originY={node.point[1]} $outlined={outlined} style={{
        ...(isActive ? {
          fontWeight: 'bold'
        } : undefined),
        ...(color ? {
          fill: color
        } : undefined)
      }}>
            {label}
          </LabelText>;
    })}
    </>;
};